export const currency = (value: number) =>
  value.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  AUD: 'A$',
  KRW: '₩',
};

/** Trust/rating copy shown in the checkout order summary. */
export const matchPromo = {
  trust: 'Millions of users trust our products',
  rating: 4.6,
  reviews: 267,
};

/** "Always included" reassurance bullets in the checkout order summary. */
export const alwaysIncluded: string[] = [
  'Free learning resources, support & community access',
  '14-day money back guarantee.',
  'Limited time introductory prices',
];

/** Links used in the checkout legal fine print. */
export const legalLinks = {
  privacy: 'https://www.chaos.com/privacy',
  terms: 'https://www.chaos.com/terms',
  eula: 'https://www.chaos.com/eula',
};

/** Where the "valid evidence of enrollment" disclosure links out to. */
export const eduEligibilityLink =
  'https://support.chaos.com/hc/en-us/sections/4403307529489-Academic-Pricing-Eligibility';
